import { refreshFolders } from '.';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { notify } from '../../actions/notifications';
import { unselectAll } from '../../actions/selected';
import {
  fetchRemoveOffersFromFolder,
  IRemoveOffersFromFolderRequest,
  TRemoveOffersFromFolderResponse,
} from '../../repositories/favorites/v1/remove-offers-from-folder';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export const removeOffersFromFolder =
  (offerIds: number[], folderId: number): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const parameters: IRemoveOffersFromFolderRequest = {
      folderId,
      offerIds,
    };

    const showError = () => dispatch(notify('Не удалось удалить объекты из подборки', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TRemoveOffersFromFolderResponse = await fetchRemoveOffersFromFolder({
        httpApi,
        parameters,
      });

      if (statusCode === 200) {
        dispatch(unselectAll());
        dispatch(fetchFavoriteEntities({ offset: 0 }));
        dispatch(refreshFolders());
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Fail to remove offers from folder (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, {
        description: 'Fail to remove offers from folder',
      });
    }
  };
